import Component from "../Component";
import SessionFiltersGate from "../../../components/shared/filters/SessionFiltersGate";
import { SCHEDULE_TRANSIENT_PARAMS } from "../Component/constants/scheduleTypes";
import DateFiltersProvider from "../../../components/shared/filters/DateFilters/context";
import { ScheduleProvider } from "../Component/context/Schedule";
import { ScrollProvider } from "../Component/context/Scroll";
import { MenuProvider } from "../Component/context/Menu";
import type { DateFiltersMode } from "../../../components/shared/filters/DateFilters/types";


const modes: DateFiltersMode[] = ["day", "week", "month", "custom"]

function Home() {
    return (
        <div className="tw-h-full tw-w-full tw-bg-white tw-rounded-lg">
            <SessionFiltersGate storageKey="traxxion-schedule:home" excludeParams={SCHEDULE_TRANSIENT_PARAMS}>
                <DateFiltersProvider modes={modes}>
                    <ScheduleProvider type="home">
                        <ScrollProvider>
                            <MenuProvider>
                                <Component />
                            </MenuProvider>
                        </ScrollProvider>
                    </ScheduleProvider>
                </DateFiltersProvider>
            </SessionFiltersGate>
        </div>
    );
}

export default Home;
